import React from "react";
import { TDateTimeMode } from "../../types";
import { Tooltip } from "../ui-component/tooltip/Tooltip";
import { ITileProps, TColumn, TValue } from "./SummaryCard.fixtures";
import { METRIC_DEFINITION_MAP_CONFIG } from "../../config/metric-definition";
const SPACE_HOLDER = "--";

export const Tile: React.FC<ITileProps> = ({
	column,
	data,
	dynamicallyComparedKey,
	timeMode,
}: ITileProps) => {
	const threshold = column.threshold || SPACE_HOLDER;

	const classForIndicator = `vlue
	 ${updateColors(data[column.prop], column, data, dynamicallyComparedKey)}`;

	return (
		<div>
			<div className="lbl">
				<Tooltip
					metricDefinition={METRIC_DEFINITION_MAP_CONFIG.get(
						column.prop
					)}
					key={column.name + 2}
				>
					<span>{column.name} </span>
				</Tooltip>
			</div>

			{!column.indicator && !column.sub && (
				<div className="vlue">
					<span>{data[column.prop] || SPACE_HOLDER}</span>
				</div>
			)}
			{column.indicator && column.sub && !column.dynamic_sub_name && (
				<div className={classForIndicator}>
					<span className="mar-r-xxs">
						{data[column.prop] || SPACE_HOLDER}
					</span>
					<span>
						{data[threshold] > 0 && (
							<div className="ioc-green-ind"></div>
						)}
						{data[threshold] < 0 && (
							<div className="ioc-red-ind"></div>
						)}

						<span className="l2">
							{formatValue(
								threshold,
								column,
								data,
								dynamicallyComparedKey
							)}
						</span>
						{column.subheading && (
							<span className="l3 m-l-xxs">{column.subheading}</span>
						)}
					</span>
				</div>
			)}
			{column.indicator && !column.sub && column.dynamic_sub_name && (
				<div className={classForIndicator}>
					{data[column.prop] > 0 && (
						<div className="ioc-green-ind"></div>
					)}
					{data[column.prop] < 0 && (
						<div className="ioc-red-ind"></div>
					)}

					<span>
						{formatValue(
							column.prop,
							column,
							data,
							dynamicallyComparedKey
						)}
					</span>
					{
						(column.suffixProp) && (
							<span style={{marginLeft: 2}} className={`vlue ${data[column.suffixProp] >= 0 ? 'vlue-l2-ind-green' : data[column.suffixProp] < 0 ? 'vlue-l2-ind-red' : ''}`}>
								<span style={{marginLeft: 0, fontSize: 14}} className="l2">
									(
									{data[column.suffixProp] >= 0 && (
										<div className="ioc-green-ind-new"></div>
									)}
									{data[column.suffixProp] < 0 && (
										<div className="ioc-red-ind-new"></div>
									)}

									<span>
										{formatValue(
											column.suffixProp,
											column,
											data,
											dynamicallyComparedKey
										)}%
									</span>
									)
								</span>
							</span>
						)
					}
					<span>
						<span className="l3 m-l-xxs">
							{getSubName(column, timeMode)}
						</span>
					</span>
				</div>
			)}
		</div>
	);
};

const getSubName = (col: TColumn, timeMode: TDateTimeMode): string => {
	if (col.dynamic_sub_name) {
		return timeMode !== "TODAY" ? col.subheading2 : col.subheading;
	} else {
		return col.subheading;
	}
};

// remove minus and return value or zero
const getAbsoluteValue = (key: number | string, data: object): number => {
	if (data[key]) {
		if (data[key] < 0) {
			return Math.abs(data[key]);
		}
		return data[key];
	}

	return 0;
};

const formatValue = (
	key: TValue,
	col: TColumn,
	data: object,
	dynamicallyComparedKey: TValue
) => {
	if (col.threshold_type === "plus_minus") {
		// check column for Variance
		if (col.dynamic_sub_name) {
			// get actual production
			const subThreshold = data[col.compared_attribute];
			// get planned production or RTT
			const dynamicThreshold = data[dynamicallyComparedKey]; // if RTT = Actual / Actual = Planned Production
			if (subThreshold === 0 && dynamicThreshold === 0) {
				return SPACE_HOLDER;
			} else if (subThreshold === dynamicThreshold) {
				return 0; // if RTT = Actual = 0 / Actual = Planned Production = 0
			}

			return getAbsoluteValue(key, data);
		} else if (col.sub && !col.dynamic_sub_name) {
			// if trend == 0
			if (data[key] === 0) {
				return SPACE_HOLDER;
			}

			return getAbsoluteValue(key, data);
		}

		return getAbsoluteValue(key, data);
	}
};

const updateColors = (
	value: TValue,
	col: TColumn,
	data: object,
	dynamicallyComparedKey: TValue
) => {
	if (col.threshold_type === "plus_minus") {
		if (col.indicator && value !== SPACE_HOLDER) {
			// check column for Variance
			if (col.dynamic_sub_name) {
				// get actual production
				const subThreshold = data[col.compared_attribute];
				// get planned production or RTT = dynamicComparedKey
				const dynamicThreshold = data[dynamicallyComparedKey];

				if (subThreshold === 0 && dynamicThreshold === 0) {
					return "";
				}

				if (subThreshold === dynamicThreshold) {
					return col.upper_threshold_color;
				}

				//const threshold_value = data[col.threshold];
				if (data[col.threshold] < 0) {
					return col.lower_threshold_color;
				}

				return col.upper_threshold_color;
			}

			// check column for not Variance
			const threshold_value = data[col.threshold];
			if (threshold_value) {
				if (threshold_value < 0) {
					return col.lower_threshold_color;
				}

				return col.upper_threshold_color;
			}

			return "";
		}

		return "";
	}
};
